import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { renderControlGroup } from '../../utils/ui';
import IconDelete from '../../ui/Icons/IconClose';
import {
  subscribeSavedSearch,
  unsubscribeSavedSearch,
  getCountAnnouncementBySavedSearch
} from './actions';
import { DEFAULT_FILTER } from '../Search/filter';
import {
  gtagPushEventNewPage,
  getCianDealType,
  getCianObjectType,
  getExtraCategory
} from '../../utils/googleAnalytics';
import GtagBuilder from '../../classes/builder/gtagEventBuilder';

class SavedSearchItem extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isSubscribed: this.props.item.get('isSubscribed'),
      announcementCounterLoaded: false,
      announcementCounter: 0,
      announcementDescription: 'объектов'
    };
    this.renderIsSubscribed = this.renderIsSubscribed.bind(this);
    this.subscribe = this.subscribe.bind(this);
    this.unsubscribe = this.unsubscribe.bind(this);
  }

  componentDidMount () {
    const { getCountAnnouncementBySavedSearch, item, user, domain } = this.props;
    const filterItem = item.get('filters');
    if (filterItem.page === undefined && filterItem.viewMode === undefined) {
      filterItem.page = 1;
    }
    const originalFilter = filterItem.merge(DEFAULT_FILTER);
    const regionId = originalFilter.get('regionId', null) || domain.get('regionId');
    const localityId = originalFilter.get('localityId', null) || domain.get('localityId', null);
    const token = user.get('token', null);
    const currentFilter = originalFilter
    .merge(filterItem)
    .set('regionId', regionId)
    .set('localityId', localityId)
    .set('token', token);

    getCountAnnouncementBySavedSearch(item.get('dealType'), item.get('realtyType'), currentFilter.toJS()).then(data => {
      this.setState({
        announcementCounterLoaded: true,
        announcementCounter: data.payload.count || 0,
        announcementDescription: data.payload.what || 'объектов'
      });
    });
  }

  subscribe (filterId) {
    const { subscribeSavedSearch, user, domain, item } = this.props;
    if (!this.state.isSubscribed) {
      subscribeSavedSearch(filterId).then(() => {
        this.setState({
          isSubscribed: true
        });
        const cianGtagEvent = new GtagBuilder({})
          .setEvent('oldevent')
          .setEventCategory('subscription')
          .setEventAction('Send')
          .setEventLabel('From_listing')
          .setUser(user)
          .setPage({
            pageType: 'ListingFavorites',
            siteType: 'desktop',
            listingType: 'list',
            dealType: getCianDealType(item.get('dealType')),
            objectType: getCianObjectType(item.get('realtyType')),
            sortType: 'default',
            region: domain.get('regionName').replace(/\.$/, ''),
            offersQty: this.state.announcementCounter,
            pageNumber: null,
            extra: {
              category: getExtraCategory(item.get('dealType'), item.get('realtyType'))
            }
          })
          .getEvent();
        gtagPushEventNewPage(cianGtagEvent);
      });
    }
  }

  unsubscribe (filterId) {
    const { unsubscribeSavedSearch, user, domain, item } = this.props;
    if (this.state.isSubscribed) {
      unsubscribeSavedSearch(filterId).then(() => {
        this.setState({
          isSubscribed: false
        });
        const cianGtagEvent = new GtagBuilder({})
          .setEvent('oldevent')
          .setEventCategory('unsubscription')
          .setEventAction('Activation')
          .setEventLabel('From_listing')
          .setUser(user)
          .setPage({
            pageType: 'ListingFavorites',
            siteType: 'desktop',
            listingType: 'list',
            dealType: getCianDealType(item.get('dealType')),
            objectType: getCianObjectType(item.get('realtyType')),
            sortType: 'default',
            region: domain.get('regionName').replace(/\.$/, ''),
            offersQty: this.state.announcementCounter,
            pageNumber: null,
            extra: {
              category: getExtraCategory(item.get('dealType'), item.get('realtyType'))
            }
          })
          .getEvent();
        gtagPushEventNewPage(cianGtagEvent);
      });
    }
  }

  renderIsSubscribed (item) {
    const filterId = item.get('id');
    const notSubscribedClass = classNames('btn btn-base', { pressed: !this.state.isSubscribed });
    const subscribedClass = classNames('btn btn-base', { pressed: this.state.isSubscribed });

    return renderControlGroup('', (
      <div className='btn-group-pills btn-group-new-old' role='group'>
        <button type='button' onClick={() => this.unsubscribe(filterId)} className={notSubscribedClass}>Нет</button>
        <button type='button' onClick={() => this.subscribe(filterId)} className={subscribedClass}>Да</button>
      </div>
    ));
  }

  render () {
    const { item, openDeleteModal, openSavedSearch } = this.props;
    const { announcementCounterLoaded, announcementCounter, announcementDescription } = this.state;
    return (
      <div className='saved-searches__item'>
        <div className='saved-searches__link-container'>
          <div>
            <div className='saved-searches__link' onClick={() => openSavedSearch(item.get('filters'))}>
              {item.get('name')}
            </div>
            <div className='saved-searches__subscription'>
              <div className='saved-searches__subscription-label'>
                Присылать новые объявления на эл. почту
              </div>
              {this.renderIsSubscribed(item)}
            </div>
            <div className='saved-searches__counter'>
              <div className='saved-searches__counter-label'>
                {announcementCounterLoaded ? `Нашли ${announcementCounter} ${announcementDescription}`
                : (
                  <div className='counter-waiting-overlay'>
                    <div className='radial-progress'>
                      <div className='circle'>
                        <div className='fill' />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='saved-searches__delete' onClick={() => openDeleteModal(item.get('id'))}>
            <IconDelete />
          </div>
        </div>
      </div>
    );
  }
}

SavedSearchItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    isSubscribed: PropTypes.bool
  }).isRequired,
  openDeleteModal: PropTypes.func.isRequired,
  subscribeSavedSearch: PropTypes.func.isRequired,
  unsubscribeSavedSearch: PropTypes.func.isRequired,
  getCountAnnouncementBySavedSearch: PropTypes.func.isRequired,
  openSavedSearch: PropTypes.func.isRequired
};

SavedSearchItem.defaultProps = {
};

function mapStateToProps (state) {
  return {
  };
}

function mapDispatchToProps (dispatch) {
  const actions = bindActionCreators({
    subscribeSavedSearch,
    unsubscribeSavedSearch,
    getCountAnnouncementBySavedSearch
  }, dispatch);

  actions.dispatch = dispatch;
  return actions;
}

export default connect(mapStateToProps, mapDispatchToProps)(SavedSearchItem);



// WEBPACK FOOTER //
// ./src/app/SavedSearch/SavedSearchItem.jsx